import React from 'react';
import Pagination from './Pagination';
import Search from './Search';
import CreateTable from './CreateTable';
import Text from './Text';
import Table from '../containers/Table';
import './../../../../node_modules/react-quill/dist/quill.snow.css';
import { useSelector } from 'react-redux';
import { getAggregatedOptions } from '../selectors/tableEditor';
import ContextMenu from './ContextMenu';
import ExportMenu from './ExportMenu';

export default function TableComponent(props) {
  const { customizedOptions } = useSelector((state) => state.projectConfig);
  const { resolution } = useSelector((state) => state.layoutEditorPage);
  const { bufferDataOptions, isGSheet, showContextMenu } = useSelector((state) => state.tableEditorPage);
  const aggregatedOptions = useSelector((state) => getAggregatedOptions(state.projectConfig));
  const { exporting } = aggregatedOptions ?? {};

  const exportEnabled = aggregatedOptions?.exporting?.enabled;
  const canvasStyle = aggregatedOptions.canvas ? aggregatedOptions.canvas.style : null;
  let headerStyle = aggregatedOptions.header ? aggregatedOptions.header.style : null;
  const logoStyle = aggregatedOptions.logo ? aggregatedOptions.logo.style : null;
  const extraContainerStyle = {
    backgroundColor: canvasStyle?.backgroundColor ?? ''
  };

  const hasExtras =
    aggregatedOptions.table &&
    (aggregatedOptions.table.pagination?.enabled || aggregatedOptions.table.searchable?.enabled);

  return (
    <div
      className={
        'canvas-container overflow-auto ev-sm-max:h-full ev-sm:h-[500px]' +
        (aggregatedOptions && aggregatedOptions.layout ? aggregatedOptions.layout.type : '')
      }
      style={resolution}
    >
      <Text
        type="title"
        placeholder="[Insert Title Here]"
        containerClass="upper"
        inputClass={`inline-component ${exportEnabled ? 'mr-[50px]' : ''}`}
      >
        {exporting?.enabled && <ExportMenu options={exporting} aggregatedOptions={aggregatedOptions} />}
      </Text>
      <Text type="subtitle" inputClass="subtitle" containerClass="subtitle" />

      <div className={'canvas'} id="canvas" style={canvasStyle}>
        <div className={'section '}>
          {bufferDataOptions.length > 0 && (
            <Table headerStyle={headerStyle} aggregatedOptions={aggregatedOptions} hasExtras={hasExtras} />
          )}
          {bufferDataOptions.length === 0 && (
            <div className="create-table">
              <div className="create-table-text"> Create table</div>
              <CreateTable setData={props.setData} customizedOptions={customizedOptions} />
            </div>
          )}
        </div>

        {bufferDataOptions.length > 0 && !isGSheet && showContextMenu && <ContextMenu />}
      </div>
      {hasExtras && (
        <div style={extraContainerStyle}>
          <div className="extras" style={aggregatedOptions?.table?.extra?.style ?? {}}>
            {aggregatedOptions?.table?.searchable?.enabled && <Search options={aggregatedOptions.table.searchable} />}
            {aggregatedOptions?.table?.pagination?.enabled && <Pagination aggregatedOptions={aggregatedOptions} />}
          </div>
        </div>
      )}

      <Text type="caption" inputClass="subtitle" containerClass="caption" />

      {aggregatedOptions.logo && (
        <div
          className={'logo-container ' + aggregatedOptions.logo.position}
          style={{ ...logoStyle, width: aggregatedOptions.logo.width, minWidth: aggregatedOptions.logo.minWidth }}
        >
          <img src={aggregatedOptions.logo.url} />
        </div>
      )}
    </div>
  );
}
